import React from 'react';
import styles from '../styles/BrandLoadingScreen.module.css';

/**
 * The one loading screen for the app-boot chain: startup delay, token check,
 * the lazy-import wait for onboarding, and onboarding's own initialisation.
 *
 * Those four moments run back to back after a reload (paying redirects to a
 * clean URL, so the celebration is followed by exactly this sequence). They
 * used to render three different loaders, which read as the screen twitching
 * between styles. Keep any new step in that chain on this component.
 */
function BrandLoadingScreen({ subtext = 'Loading…' }) {
  return (
    <div className={styles.container}>
      <div className={styles.brand}>Sophia</div>
      <div className={styles.subtext}>{subtext}</div>
    </div>
  );
}

export default BrandLoadingScreen;
